import { useQuestionnaireStore } from '../../../lib/QuestionnaireStore';

export const useQuestionnaireValidation = (
  keyForComponent?: string
): {
  errorMessage: string;
  isQuestionnaire: boolean;
} => {
  const [getError, formType] = useQuestionnaireStore(state => [
    state.getError,
    state.formType
  ]);
  return {
    errorMessage: getError(keyForComponent ?? '')?.message ?? '',
    isQuestionnaire: formType === 'questionnaire'
  };
};
